import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export function Logo({ size = "md" }) {
  const scale = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to="/" className="flex items-center gap-2 group" data-testid="rooflead-logo">
      <div className="w-9 h-9 rounded-lg bg-orange-500 flex items-center justify-center ring-2 ring-orange-500/30 group-hover:ring-orange-500/60 transition-all">
        <Shield className="w-5 h-5 text-slate-900" strokeWidth={2.5} />
      </div>
      <span className={`font-display font-extrabold tracking-tight ${scale} text-white`}>
        roof<span className="text-orange-500">lead</span>
      </span>
    </Link>
  );
}
